module.exports = __webpack_public_path__ + "img/1487088351.54998813.jpg";